import {createContext, PropsWithChildren, useContext, useMemo} from 'react'

import {LoginStatus, UserInfo} from '$types/member'

interface UserInfoStatus {
    userInfo: UserInfo
}

const Context = createContext<UserInfoStatus | undefined>(undefined)

export function UserInfoProvider({userInfo, children}: PropsWithChildren<UserInfoStatus>) {
    const value = useMemo(
        () => ({
            userInfo,
        }),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [],
    )
    return <Context.Provider value={value}>{children}</Context.Provider>
}

export function useUserInfoContext() {
    const context = useContext(Context)

    if (context === undefined) {
        throw new Error('useUserInfoContext must be within UserInfoProvider')
    }

    return context
}

export function useLoginStatusContext(): LoginStatus {
    const context = useContext(Context)

    if (context === undefined) {
        throw new Error('useUserInfoContext must be within UserInfoProvider')
    }

    const {userInfo} = context

    return {
        isLogin: userInfo.isLogin,
        isSuccessLogin: userInfo.isSuccessLogin,
        status: userInfo.status,
    }
}
